import { cn, Typography, useMediaQuery } from "@kyan/ui";

import { Krystal } from "#/components/Krystal/Krystal";

import { KrystalsTooltip } from "./components/KrystalsTooltip";

export interface EarningsSectionProps {
  title: string;
  amount: number;
  isReferralBalance?: boolean;
  className?: string;
}

export const EarningsSection: React.FC<EarningsSectionProps> = ({
  title,
  amount,
  isReferralBalance = false,
  className,
}) => {
  const { isSm } = useMediaQuery();

  const amountComponent = (
    <Typography
      element={isSm ? "h2" : "h3"}
      className={cn({
        "text-white": !isReferralBalance || amount === 0,
        "text-[#80FF77]": isReferralBalance && amount > 0,
        "cursor-help": !isReferralBalance,
      })}
    >
      {amount}
    </Typography>
  );

  return (
    <div
      className={cn(
        "flex flex-col justify-between",
        {
          "items-end": !isReferralBalance,
        },
        className,
      )}
    >
      <KrystalsTooltip disabled={isReferralBalance}>
        <Typography
          size={isSm ? 16 : 12}
          className={cn("text-white/90", { "cursor-help": !isReferralBalance })}
        >
          {title}
        </Typography>
      </KrystalsTooltip>
      {isReferralBalance && amountComponent}
      {!isReferralBalance && (
        <KrystalsTooltip>
          <div className="flex cursor-help items-center justify-end">
            <Krystal size={30} />
            {amountComponent}
          </div>
        </KrystalsTooltip>
      )}
    </div>
  );
};
